import get from 'lodash/get';
import classNames from 'clsx';
import styles from './prompt.module.scss';

// Due to note below, since a Prompt may operate on either a guideItem or containerItem, let's make
// sure one or the other is specified.
function itemPropValidation(props) {
  if (!props.guideItem && !props.containerItem) {
    return new Error("at least one of 'guideItem' or 'containerItem' required");
  }

  return undefined;
}

// NOTE: we're looking at both guideItem and containerItem props because Prompts may be utlized on
// the list of containers level (containerItems), or list of guide items level (list layout), where
// containerItem and guideItem nomenclature are used, respectively, to denote an item to be
// rendered.
const Prompt = ({ guideItem, containerItem }) => {
  const item = guideItem || containerItem;

  if (!get(item, 'title')) {
    return null;
  }

  return (
    <div className={classNames('row', styles.container)}>
      <div className="col-xs-offset-1 col-xs-10 col-sm-offset-2 col-sm-8">
        <div id="prompt" className={styles.prompt}>
          <div className={styles.text} data-testid="promptText">
            {item.image && (
              <div>
                <img
                  src={item.image}
                  alt={item.title}
                  className={styles.thumb}
                />
              </div>
            )}
            {item.title}
          </div>
        </div>
      </div>
    </div>
  );
};

Prompt.propTypes = {
  guideItem: itemPropValidation,
  containerItem: itemPropValidation,
};

export default Prompt;
